export const interestRates = {
  interestRates: {
    ThreeMonths: 3.84,
    OneYear: 3.49,
    TwoYears: 3.36,
    ThreeYears: 3.34,
    FourYears: 3.34,
    FiveYears: 3.34,
    SixYears: 3.39,
    TenYears: 3.59,
  },
};
